<template>
  <vs-popup class="vs-con-loading__container update-staff-group-popup" id="popup" title="UPDATE STAFF GROUP"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickGroupUpdate)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Group Name</small>
                <vs-input v-model="selectedGroup.name" required name="name" class="w-full required" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <small class="label">Group Description</small>
              <vs-textarea v-model="selectedGroup.description" height="100px" />
            </div>
          </div>

          <h3 class="mt-4 mb-10">Role Permisions</h3>
          <div class="vx-row my-6">
            <div class="vx-col w-full">
              <vs-checkbox @input="onInputSelectAll()" class="float-right" v-model="is_select_all">Select
                All</vs-checkbox>
            </div>
          </div>
          <div class="vx-row mb-10 text-sm" v-for="(group, index) in allPermissions" :key="index">
            <div class="vx-col w-1/5">
              <b>{{ group.group_label }}</b>
            </div>
            <div class="vx-col w-4/5">
              <div class="vx-row">
                <div class="vx-col w-1/4" v-for="(permission, index) in group.permissions" :key="index">
                  <vs-checkbox v-model="selectedGroup.permissions" :vs-value="permission">
                    {{ capitalizeWords(permission) }}
                  </vs-checkbox>
                </div>
              </div>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="onClickReset" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const RolesRepository = RepositoryFactory.get('roles')
const PermissionRepository = RepositoryFactory.get('permissions')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    selectedGroup: {},
    id: null,
    allPermissions: [],
    is_select_all: false
  }
}
export default {
  name: 'UpdateStaffGroupPopUp',
  data() {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],
  methods: {
    async openPopup(id) {
      await Object.assign(this.$data, initialState())
      this.open = true;
      this.$vs.loading()
      await this.$forceUpdate()
      await this.initialize(id)
      this.id = id
      this.$vs.loading.close()
    },
    onInputSelectAll() {
      this.selectedGroup.permissions = this.is_select_all ? this.allPermissions.map(group => group.permissions).flat() : []
    },
    async onClickGroupUpdate() {
      const vue = this
      this.$vs.loading()
      try {
        await RolesRepository.updateRole(this.id, this.selectedGroup)
        this.showSuccessMessage('Selected staff group update successfully!')
        this.open = false;
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
      await vue.$parent.refreshData()
    },
    async initialize(id) {
      try {
        const { data } = (await RolesRepository.getRole(id)).data
        this.selectedGroup = data

        this.allPermissions = (await PermissionRepository.get()).data.data

        if (this.selectedGroup.permissions.length === this.allPermissions.map(group => group.permissions).flat().length) {
          this.is_select_all = true
        }
      } catch (error) {
        this.showErrorMessage('Something went wrong!')
      }
    },
    capitalizeWords(str) {
      return str.replace(/\b\w/g, char => char.toUpperCase()).replaceAll('-', ' ')
    },
    async onClickReset() {
      this.$vs.loading();
      await this.initialize(this.id)
      this.$vs.loading.close();
    }
  },
}
</script>

<style scoped>
.update-staff-group-popup>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 70% !important;
}
</style>
